var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable camelcase */
import { defaultMetalCupMaterialTransform, } from "3d/types";
/** ---------------   **/
/**    FCF Family     **/
/** ---------------   **/
export var suctionCupsFamilyFCF = {
    FCF: __assign(__assign({ cupModelName: "FCF75P", cupWidth: 0.075, cupHeight: 0.075 }, defaultMetalCupMaterialTransform.PU55), { fittingModelName: "G38M01-FCF75P" }),
    // FCF25P
    suction_cup_0201827: __assign(__assign({ cupModelName: "FCF25P", cupWidth: 0.025, cupHeight: 0.025 }, defaultMetalCupMaterialTransform.PU55), { fittingModelName: "G38M01-S1" }),
    // FCF35P
    suction_cup_0119913: __assign(__assign({ cupModelName: "FCF35P", cupWidth: 0.035, cupHeight: 0.035 }, defaultMetalCupMaterialTransform.PU55), { fittingModelName: "G38M01-S3" }),
    // FCF50P
    suction_cup_0118985: __assign(__assign({ cupModelName: "FCF50P", cupWidth: 0.05, cupHeight: 0.05 }, defaultMetalCupMaterialTransform.PU55), { fittingModelName: "G38M01-S3" }),
};
